import React from 'react'
import default_Image from '../../../assets/images/default_image.jpg'
import { Link, useHistory, useParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Multiselect } from 'multiselect-react-dropdown';
import {
  getMarketplaceProductByStoreId, searchProducts, getItalianRegion,
  getProductCategories, getProductProperties, getConservationMethod,getProductPropertiesAndConservation
} from '../modules/marketplace';
import ReactPaginate from 'react-paginate';
import FormSpinner from '../../../components/Spinners/FormSpinner';
import constant from '../../../helpers/constant';
import auth from '../../../helpers/auth';
import language from '../../../helpers/language';
import CustomUseEffect from '../../../components/constants';

export default function ProducertStore() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [lang] = useState(language.getLang());
  const myProductTypeRef = useRef(null);
  const myConservationRef = useRef(null);
  const myItalianRegionRef = useRef(null);
  const myProductPropertyRef = useRef(null);
  const myFDACertificateRef = useRef(null);
  const [isSelected, setIsSelected] = useState(false)
  const [pageNo, setPageNo] = useState(0);
  const [searchFdaData, setSearchFdaData] = useState([]);
  const [validationText, setValidationText] = useState('');
  const [searchProductCategories, setSearchProductCategories] = useState();
  const [searchProductProperties, setSearchProductProperties] = useState();
  const [searchConservationMethods, setSearchConservationMethods] = useState();
  const [selectedcategoryArray, setSelectedCategoryArray] = useState([]);
  const [searchItalianRegion, setSearchItalianRegion] = useState();
  const [selectedRegionsArray, setSelectedRegionsArray] = useState([])
  const [productKeyword, setProductKeyword] = useState('');
  const [user, setUser] = useState([]);
  const [fdaCertifiedStatus, setFdaCertified] = useState([{ key: lang?.yes, value:"1" },{ key: lang?.no, value:"0" }]);
  const [conservationPropertyDisabled, setConservationPropertyDisabled] = useState(true);

  CustomUseEffect(async () => {
    window.scrollTo(0, 0);
    if (id !== undefined || id !== "") {
      setSearchItalianRegion(id);
    }
    const user = await auth.getUserType();
    await setUser(JSON.parse(user));
    await dispatch(getMarketplaceProductByStoreId(id));
    (productCategories && productCategories.length === 0) && await dispatch(getProductCategories());
    (productProperties && productProperties.length === 0) && await dispatch(getProductProperties());
    (conservationMethods && conservationMethods.length === 0) && await dispatch(getConservationMethod());
    (italianRegions && italianRegions.length === 0) && await dispatch(getItalianRegion());
  }, []);

  let {
    ProductByItalianRegionsId,
    marketPlaceSpinner,
    productCategories,
    productProperties,
    conservationMethods,
    conservationMethodLabel,
    productPropertiesLabel,
    italianRegions,
  } = useSelector((state) => state.marketPlaceReducerData);

  // CustomUseEffect(async () => {
  //   if (italianRegions && italianRegions.length) {
  //     let selectedArr = [];
  //     italianRegions.map(function (region) {
  //       if (id == region.id) {
  //         selectedArr.push(region);
  //       }
  //       console.log(selectedArr,'selectedArr')
  //       setSelectedRegionsArray(selectedArr);
  //       setSearchItalianRegion(id);
  //       if (selectedArr.length > 1) {
  //         document.getElementById('region_input').placeholder = selectedArr[0].name + " +" + (selectedArr.length - 1) + " more";
  //       } else if (selectedArr.length == 1) {
  //         document.getElementById('region_input').placeholder = selectedArr[0].name;
  //       } else {
  //         document.getElementById('region_input').placeholder = "Select";
  //       }
  //     });

  //   }
  // }, [italianRegions]);

  const changeProductCategories = async(e) => {
    await setSearchProductCategories(e[0].marketplace_product_category_id);
    await setSelectedCategoryArray(e);
    await dispatch(getProductPropertiesAndConservation(e[0].marketplace_product_category_id));
    await setConservationPropertyDisabled(false);
  };
  // const changeProductCategories = async(prouctCategoprySelectedList) => {
  //   if (prouctCategoprySelectedList.length > 1) {
  //     document.getElementById('product_categories_input').placeholder = prouctCategoprySelectedList[0].name + " +" + (prouctCategoprySelectedList.length - 1) + " more";
  //   } else if (prouctCategoprySelectedList.length === 1) {
  //     document.getElementById('product_categories_input').placeholder = prouctCategoprySelectedList[0].name;
  //   } else {
  //     document.getElementById('product_categories_input').placeholder = lang?.select;
  //   }

  //   let data = prouctCategoprySelectedList.map((item, i) => {
  //     return item.marketplace_product_category_id;
  //   });


  //   if (data.length > 0) {
  //     setSearchProductCategories(data.join());
  //   } else {
  //     setSearchProductCategories("");
  //   }
  //   await setConservationPropertyDisabled(false);
  // }
  const changeConservationMethods = (conservationMethodSelectedList) => {
    if (conservationMethodSelectedList.length > 1) {
      document.getElementById('conservation_method_input').placeholder = conservationMethodSelectedList[0].option + " +" + (conservationMethodSelectedList.length - 1) + " more";
    } else if (conservationMethodSelectedList.length == 1) {
      document.getElementById('conservation_method_input').placeholder = conservationMethodSelectedList[0].option;
    } else {
      document.getElementById('conservation_method_input').placeholder = lang?.select;
    }

    let data = conservationMethodSelectedList.map((item, i) => {
      return item.option;
    });

    if (data.length > 0) {
      setSearchConservationMethods(data.join());
    } else {
      setSearchConservationMethods("");
    }

  }

  const changeProductProperties = (productCategorySelectedList) => {
    if (productCategorySelectedList.length > 1) {
      document.getElementById('product_properties_input').placeholder = productCategorySelectedList[0].option + " +" + (productCategorySelectedList.length - 1) + " more";
    } else if (productCategorySelectedList.length == 1) {
      document.getElementById('product_properties_input').placeholder = productCategorySelectedList[0].option;
    } else {
      document.getElementById('product_properties_input').placeholder = lang?.select;
    }

    let data = productCategorySelectedList.map((item, i) => {
      return item.option;
    });

    if (data.length > 0) {
      setSearchProductProperties(data.join());
    } else {
      setSearchProductProperties("");
    }
  }

  const changeItalianRegions = (italianRegionSelectedList) => {

    if (italianRegionSelectedList.length > 1) {
      setIsSelected(true);
      document.getElementById('region_input').placeholder = italianRegionSelectedList[0].name + " +" + (italianRegionSelectedList.length - 1) + " more";
    } else if (italianRegionSelectedList.length == 1) {
      setIsSelected(true);
      document.getElementById('region_input').placeholder = italianRegionSelectedList[0].name;
    } else {
      document.getElementById('region_input').placeholder = lang?.select;
    }

    let data = italianRegionSelectedList.map((item, i) => {
      return item.id;
    });

    if (data.length > 0) {
      setSearchItalianRegion(data.join());
    } else {
      setSearchItalianRegion("");
    }
  }

  const handleSearch = async () => {
    // let queryString = "?";
    // if (searchProductCategories !== undefined) {
    //   queryString += "category=" + searchProductCategories

    // }

    // if (searchProductProperties !== undefined) {
    //   queryString += "&property=" + searchProductProperties;
    // }

    // if (searchConservationMethods !== undefined) {
    //   queryString += "&method=" + searchConservationMethods;
    // }

    // if (searchFdaData > -1) {
    //   queryString += "&fda_certified=" + searchFdaData;
    // }

    // if (searchItalianRegion !== undefined) {
    //   queryString += "&fda_certified=" + searchItalianRegion;
    // }

    // if (activeTab) {
    //   queryString += "&tab=" + activeTab
    // }
    const searchProductData = {
      property: searchProductProperties,
      category: searchProductCategories,
      method: searchConservationMethods,
      fda_certified: searchFdaData,
      region: searchItalianRegion,
      keyword: productKeyword,
      box_id: 2,
      type: 2,
      sort_by_product: 1,
    };
    (searchProductCategories || searchConservationMethods || searchProductProperties || searchFdaData.length > 0 || (searchItalianRegion.length > 0 && isSelected) || productKeyword.length > 0) ? await dispatch(searchProducts(searchProductData)) : setValidationText("Please select at least one field.");
    setTimeout(() => {
      setValidationText('');
    }, 3000);
  }

  const handleClearCheckBox = async () => {
  
    myConservationRef.current.resetSelectedValues();
    myProductPropertyRef.current.resetSelectedValues();
    myFDACertificateRef.current.resetSelectedValues();
    myProductTypeRef.current.resetSelectedValues();
    myItalianRegionRef.current.resetSelectedValues();
    document.getElementById('conservation_method_input').placeholder =
        lang?.select;
    document.getElementById('product_properties_input').placeholder =
        lang?.select;
    document.getElementById('region_input').placeholder =
        lang?.select;
    setProductKeyword("")
    setSearchProductCategories("");
    setSearchConservationMethods("");
    setSearchProductProperties("");
    setSearchFdaData([]);
    setSearchItalianRegion("");
  }

  const changeFDACertificate = (e) => {
    setSearchFdaData(e[0].value);
  };
  // const changeFda = (e) => {
  //   if (e.target.value !== "-1") {
  //     setSearchFdaData(e.target.value);
  //   } else {
  //     setSearchFdaData([]);
  //   }
  // }
  const handlePageClick = async (e) => {
    const selectedPage = e.selected + 1;
    await setPageNo(selectedPage + 1);
    const pageChangeData = {
      category: searchProductCategories,
      property: searchProductProperties,
      method: searchConservationMethods,
      fda_Certified: searchFdaData.length > 0 ? searchFdaData : '',
      region: searchItalianRegion,
      keyword: productKeyword,
      box_id: 2,
      type: 2,
      pageNo: selectedPage,
      sort_by_product: 1,
    };
    (searchProductCategories == undefined && searchProductProperties == undefined && searchConservationMethods == undefined && searchFdaData.length == 0)
      ? dispatch(getMarketplaceProductByStoreId(id, selectedPage))
      : dispatch(searchProducts(pageChangeData));
  };

  const handlefilter = async (event) => {
    let selectValue = event.target.value;
    const filterData = {
      category: searchProductCategories,
      property: searchProductProperties,
      method: searchConservationMethods,
      fda_Certified: searchFdaData.length > 0 ? searchFdaData : '',
      region: searchItalianRegion,
      keyword: productKeyword,
      box_id: 2,
      type: 2,
      pageNo,
      sort_By_Producer: parseInt(selectValue),
    };
    await dispatch(searchProducts(filterData));

  }
  return (
    <div className="marketplace producerScore mrkt-place-three producer--store italian">
      <div className="">
        <div className="section__wrapper">
          <div className="banner__form">
            <div className="flex justify-between items-center mb-3" onClick={() => history.goBack()}>
              <a href="javascript:void(0)" className="back__btn">
                <i className="fa fa-arrow-left" aria-hidden="true" />&nbsp;
                {lang?.Go_back}
              </a>
            </div>
            <div className="tabs middle-long__section-block">
              <div className="reset text-center ">
                <h5 className="heading--w text-black">{validationText}</h5>
              </div>
              <div className="tabs__wrapper">
                <span tab={1} className="btn active-button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24.506" height="26.527" viewBox="0 0 24.506 26.527"><defs><style dangerouslySetInnerHTML={{ __html: ".a{fill:#37a282;}" }} /></defs><path className="a" d="M10.8,6A1.529,1.529,0,0,0,9.34,7.066L8.473,9.78c-.031.1-.066.209-.1.311a1.531,1.531,0,0,0-.725,2.781,30.929,30.929,0,0,0,.006,12.783,1.528,1.528,0,0,0,.719,2.781c.031.1.061.209.1.311l.867,2.714a1.529,1.529,0,0,0,1.46,1.066H27.674a1.529,1.529,0,0,0,1.46-1.066L30,28.747c.036-.1.066-.209.1-.311a1.528,1.528,0,0,0,.719-2.781,30.929,30.929,0,0,0,.006-12.783,1.531,1.531,0,0,0-.725-2.781c-.031-.1-.066-.209-.1-.311l-.867-2.714A1.529,1.529,0,0,0,27.674,6Zm0,1.02h2.994L13.34,9.857c-.01.077-.025.148-.03.224H9.447l.867-2.7A.5.5,0,0,1,10.8,7.02Zm4.024,0h3.9v3.061h-4.39a.32.32,0,0,1,.01-.067Zm4.923,0h3.9l.479,2.994a.32.32,0,0,0,.01.067H19.747Zm4.933,0h2.994a.5.5,0,0,1,.485.357l.867,2.7H25.164c0-.077-.02-.148-.03-.224ZM8.524,11.1H29.95a.51.51,0,1,1,0,1.02H8.524a.51.51,0,1,1,0-1.02Zm.113,2.041h4.279a61.126,61.126,0,0,0-.133,10.8.511.511,0,0,0,.51.469h.036a.505.505,0,0,0,.469-.546,60.747,60.747,0,0,1,.142-10.728h4.786V25.385H8.636a30,30,0,0,1,0-12.243Zm11.111,0h10.09a30,30,0,0,1,0,12.243H25.563a60.347,60.347,0,0,0,.28-7.825.507.507,0,0,0-.5-.5h-.016a.51.51,0,0,0-.5.526,58.982,58.982,0,0,1-.285,7.8h-4.8Zm5.389.9a.51.51,0,0,0-.469.548c.029.369.053.738.076,1.108a.51.51,0,0,0,.508.479h.032a.509.509,0,0,0,.478-.539q-.034-.564-.077-1.126a.513.513,0,0,0-.549-.473ZM9.8,14.672a.51.51,0,1,0,0,1.02h1.02a.51.51,0,1,0,0-1.02Zm-.255,2.551a.51.51,0,0,0,0,1.02h1.02a.51.51,0,1,0,0-1.02Zm0,2.551a.51.51,0,0,0,0,1.02h1.02a.51.51,0,1,0,0-1.02ZM9.8,22.325a.51.51,0,0,0,0,1.02h1.02a.51.51,0,1,0,0-1.02ZM8.524,26.406H29.95a.51.51,0,1,1,0,1.02H8.524a.51.51,0,1,1,0-1.02Zm.924,2.041H13.3c.01.077.026.148.036.224l.454,2.837H10.8a.5.5,0,0,1-.485-.357Zm4.887,0h4.392v3.061h-3.9l-.479-2.994a.547.547,0,0,1-.014-.068Zm5.412,0h4.392a.32.32,0,0,1-.01.067l-.479,2.994h-3.9Zm5.423,0h3.856l-.867,2.7a.5.5,0,0,1-.485.357H24.68l.454-2.837c.01-.073.026-.144.036-.221Z" transform="translate(-6.983 -6)" /></svg>
                  <em><Link to="/searchproduct" >{lang?.only_product}</Link></em>
                </span>
              </div>
              <div className="tab home-section active-tab mob-p-0">
                <div className="tab-content-left-section">
                  <div className="banner__form">
                    <form>
                      <div className="flex flex-wrap items-center banner-form-bg">

                        <div className="col-w-8">
                          <div className="form__item">
                            <label>{lang?.only_title}</label>
                            <input type="text" placeholder={`${lang?.only_product} ${lang?.Keywords}`} id="keyword" value={productKeyword} onChange={e => setProductKeyword(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-w-8">
                          <div className="form__item">
                            <label>{lang?.Product_Type}</label>
                            {/* <Multiselect
                              options={productCategories}
                              onSelect={changeProductCategories}
                              onRemove={changeProductCategories}
                              displayValue="name"
                              showCheckbox="true"
                              id="product_categories"
                              placeholder={lang?.select}
                              singleSelect
                              ref={myProductTypeRef}
                            /> */}
                            <Multiselect
                                options={productCategories}
                                displayValue="name"
                                onSelect={changeProductCategories}
                                selectedValues={selectedcategoryArray}
                                placeholder={lang?.select}
                                id={"fda__certificate"}
                                singleSelect
                                ref={myProductTypeRef}
                              />
                          </div>
                        </div>
                        <div className="col-w-8">
                          <div className="form__item">
                            <label>
                              {conservationMethodLabel != ""
                                ? conservationMethodLabel
                                : lang?.Conservation_Method}
                            </label>
                            <Multiselect
                              options={conservationMethods}
                              onSelect={changeConservationMethods}
                              onRemove={changeConservationMethods}
                              displayValue="option"
                              showCheckbox="true"
                              id="conservation_method"
                              showArrow={true}
                              placeholder={lang?.select}
                              closeOnSelect={false}
                              ref={myConservationRef}
                              disable={conservationPropertyDisabled}
                            />
                          </div>
                        </div>
                        <div className="col-w-8">
                          <div className="form__item">
                            <label>
                              {productPropertiesLabel != ""
                                ? productPropertiesLabel
                                : lang?.Product_Properties}
                            </label>
                            <Multiselect
                              options={productProperties}
                              onSelect={changeProductProperties}
                              onRemove={changeProductProperties}
                              displayValue="option"
                              showCheckbox="true"
                              id="product_properties"
                              showArrow={true}
                              closeOnSelect={false}
                              placeholder={lang?.select}
                              ref={myProductPropertyRef}
                              disable={conservationPropertyDisabled}
                            />
                          </div>
                        </div>
                        <div className="col-w-8">
                          <div className="form__item">
                            <label>{lang?.Italian_Region}</label>
                            <Multiselect
                              options={italianRegions}
                              onSelect={changeItalianRegions}
                              onRemove={changeItalianRegions}
                              displayValue="name"
                              showCheckbox="true"
                              showArrow={true}
                              placeholder={lang?.select}
                              id="region"
                              closeOnSelect={false}
                              ref={myItalianRegionRef}
                            />
                          </div>
                        </div>
                        <div className="col-w-8">
                          <div className="form__item">
                            <label>{lang?.FDA_Certification}</label>
                            <Multiselect
                                options={fdaCertifiedStatus}
                                displayValue="key"
                                onSelect={changeFDACertificate}
                                placeholder={lang?.select}
                                id={'fda__certificate'}
                                singleSelect
                                ref={myFDACertificateRef}
                              />
                            {/* <select id="hor" onChange={changeFda}>
                              <option value="-1">{lang?.select}</option>
                              <option value="1">{lang?.yes}</option>
                              <option value="0">{lang?.no}</option>
                            </select> */}
                          </div>
                        </div>
                        <div className="col-w-8">
                          <div className="btn-blue-bg">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => { handleSearch() }}
                            >{lang?.Search}</button>
                          </div>
                        </div>
                      </div>
                      <div className="reset text-left pl-2 pb-4">
                        <Link to="#">
                          <a onClick={() => handleClearCheckBox()}>{(searchProductCategories || searchConservationMethods || searchProductProperties || searchFdaData?.length > 0 || (searchItalianRegion?.length > 0 && isSelected) || productKeyword?.length > 0) && lang?.Reset_Filter}</a>
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="product-type mt-4">
            <div className="list-data-title flex flex-wrap justify-between items-center">
              <h4 className="font-20 mt-0">{lang?.Product_listing} <span className="font-16 ml-2">{ProductByItalianRegionsId && ProductByItalianRegionsId.total} {""}results</span></h4>
              <div className="flex form__item items-center">
                <span className="ml-3">{lang?.Sort_by}</span>
                <div className="mrktplace select--field relative ml-3">
                  <select id="meal" onChange={(event) => handlefilter(event)}>
                    <option value="1">{lang?.AtoZ}</option>
                    <option value="2">{lang?.ZtoA}</option>
                  </select>
                  <span className="selectDownArrow"><i className="fa fa-angle-down" aria-hidden="true"></i></span>
                </div>
              </div>
            </div>
            {marketPlaceSpinner ? <FormSpinner /> : ProductByItalianRegionsId && ProductByItalianRegionsId.data && ProductByItalianRegionsId.data.length > 0 ?
              ProductByItalianRegionsId && ProductByItalianRegionsId.data && ProductByItalianRegionsId.data.length > 0 && ProductByItalianRegionsId.data.map((items) => {
                return (
                  <div className="flex mt-2 mb--5">
                    <div className="md:w-1/3 sm:w-full">
                      <div className="col-w-left xl:pr-3 lg:pr-3 md:pr-0 sm:pr-0">
                        <div className="product-img">
                          <Link to={`/marketplace/product/${items.slug}`}>
                            {items.product_gallery && items.product_gallery.length > 0 ? <img src={`${items.product_gallery && items.product_gallery[0].base_url}${items.product_gallery && items.product_gallery[0].attachment_url}`} alt="Image" /> : items.banner_base_url != undefined ? <img src={`${items.banner_base_url}${items.banner_id}`} /> : <img src={default_Image} alt="default-Image" />}
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="md:w-2/3 sm:w-full">
                      <div className="col-w-right pl-3 xl:pr-3 lg:pr-3 md:pr-0 sm:pr-0">
                        <div className="flex justify-between blockMob">
                          <h4 className="font-18 black">{items.title}</h4>
                          {(user &&
                              user.role_id ==
                                constant.rolesId[
                                  'importer&distributer'
                                ]) ||
                            user.role_id ==
                              constant.rolesId.importer ||
                            user.role_id ==
                              constant.rolesId.distributer ? (
                              <h4 className="font-18 black sm-w-full sm--mt-1">{`$${items.product_price}`}</h4>
                            ) : (
                              ''
                            )}
                        </div>
                        <div className="review justify-between mt-2 blockMob">
                          <div className='flex items-center'>
                            <div className='rating__bg flex items-center'>
                              {/* <h4 className="font-15"> */}
                              <span className='flex items-center gap-1'>
                                {items.avg_rating}
                                <i className="fa fa-star" aria-hidden="true"></i>
                              </span>
                            </div>
                            <h4 className='font-12 pl-2'>{items.total_reviews} &nbsp;{(items.total_reviews.length <= 1) ? "Reviews" : "Review"}</h4>
                          </div>
                          <div className="prdct_nm_bg blockMob">
                            <h4 className='font-18'>{items.product_category_name}</h4>
                          </div>
                        </div>
                        <p className='mt-2 parahideMob'>
                          {items.description}
                        </p>
                        {/* <div className='mt-2'>
                          <h4 className='font-16'>{items.total_reviews}{(items.total_reviews.length <= 1) ? "Reviews" : "Review"}</h4>
                        </div> */}
                        {(user.role_id == constant.rolesId.voyagers || user.role_id == constant.rolesId.travelAgencies || user.role_id == constant.rolesId.restaurant) ? null : <div className='flex justify-between blockMob'>
                          <div className="store-name flex justify-between mt-1 blockMob">
                            <h4 className="font-16">{items.store_name}</h4>
                          </div>
                          {user.role_id ==
                            constant.rolesId.voyagers ||
                          user.role_id ==
                            constant.rolesId.travelAgencies ||
                          user.role_id ==
                            constant.rolesId.restaurant ||
                          user.role_id == constant.rolesId.producer
                            ? null
                            : items.available_for_sample ==
                                'Yes' && (
                                <div>
                                  <span className="font-16 text-black">
                                    {lang?.Available_For_Sample}
                                  </span>
                                  <i
                                    className="fa fa-check-circle pl-4"
                                    aria-hidden="true"
                                  />
                                </div>
                              )}
                        </div>}
                      </div>
                    </div>
                  </div>)
              }) : <div className="notFound text-center mt-4 mb-4"><h1>{lang?.No_data_found}.</h1></div>}
          </div>
          {ProductByItalianRegionsId?.total > 5 &&
            <ReactPaginate
              previousLabel={"prev"}
              nextLabel={"next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(ProductByItalianRegionsId.total / ProductByItalianRegionsId.per_page)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"} />}
        </div>
      </div>
    </div>
  );

}
